import React, { useEffect } from 'react';
import { useYotpo } from '../../../utils/useYotpo';
import { useUrl } from '../../../../../providers/url';

const ReviewSummary = ({ productId, title, description }) => {
  useEffect(() => {
    if (
      window.yotpoWidgetsContainer &&
      window.yotpoWidgetsContainer.initWidgets
    ) {
      window.yotpoWidgetsContainer.initWidgets();
    }
  }, []);
  const { url } = useUrl();
  const { getReviewSummary } = useYotpo();
  return (
    <div
      className="yotpo-widget-instance review-summary"
      data-yotpo-instance-id={getReviewSummary()}
      data-yotpo-product-id={productId}
      data-yotpo-name={title}
      data-yotpo-url={url}
      data-yotpo-image-url="The product image URL"
      data-yotpo-description={description}
    />
  );
};

export default ReviewSummary;
